import { render, staticRenderFns } from "./fullCalendar.vue?vue&type=template&id=1d1c52a0"
import script from "./fullCalendar.vue?vue&type=script&lang=js"
export * from "./fullCalendar.vue?vue&type=script&lang=js"
import style0 from "./fullCalendar.vue?vue&type=style&index=0&id=1d1c52a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports